import React, { lazy, Suspense } from 'react';

import { withScreenSize } from '../common/utilities/withScreenSize.jsx';

const AlertsPage = lazy(() => import('./alertsPage'));

interface LoadingUIProps {
    isDesktop: boolean;
}

const getPageMobilePageTitle = () => {
    let mobileNavTitle = 'All Alerts';
    const locationHref = location.pathname;
    if (locationHref.startsWith('/alerts/weather')) {
        mobileNavTitle = 'Weather';
    } else if (locationHref.startsWith('/alerts/spark')) {
        mobileNavTitle = 'Spark';
    } else if (locationHref.startsWith('/alerts/hurricane')) {
        mobileNavTitle = 'Hurricane';
    } else if (locationHref.startsWith('/alerts/fire')) {
        mobileNavTitle = 'Fire';
    } else if (locationHref.startsWith('/alerts/pollen')) {
        mobileNavTitle = 'Pollen';
    } else if (locationHref.startsWith('/alerts/air-quality')) {
        mobileNavTitle = 'Air Quality';
    } else if (locationHref.startsWith('/alerts/severe-storm-risk')) {
        mobileNavTitle = 'Severe Storm Risk';
    }

    return mobileNavTitle;
};

const LoadingUI = withScreenSize(({ isDesktop }: LoadingUIProps) => {
    
    return (
        <div className='container'>
            <div>
                { !isDesktop 
                    ? <div className='alerts-banner'><div style={{ width: 320, height: 50 }}></div></div>
                    : null
                }

                <div className='alerts-mobile-nav-container'>
                    <div className='alerts-mobile-nav-title'>{getPageMobilePageTitle()}</div>
                </div>

                <ul className='alerts-nav-container' data-items='9'>
                    <li><a href='/alerts' className='alerts-subnav-link'>All Alerts</a></li>
                    <li><a href='/alerts/weather' className='alerts-subnav-link'>Weather</a></li>
                    <li><a href='/alerts/spark' className='alerts-subnav-link'>Spark</a></li>
                    <li><a href='/alerts/hurricane' className='alerts-subnav-link'>Hurricane</a></li>
                    <li><a href='/alerts/fire' className='alerts-subnav-link'>Fire</a></li>
                    <li><a href='/alerts/pollen' className='alerts-subnav-link'>Pollen</a></li>
                    <li><a href='/alerts/air-quality' className='alerts-subnav-link'>Air Quality</a></li>
                    <li><a href='/alerts/severe-storm-risk' className='alerts-subnav-link'>Severe Storm Risk</a></li>
                </ul>
            </div>

            <div className='alerts-content'>
                <div className='alerts-list'>
                    <div className='alerts-header'></div>
                    <div className='alerts-item-view'></div>
                    <div className='alerts-ads'></div>
                </div>
                <div className='alerts-map'></div>
            </div>
        </div>
    );
});

export const AlertsPageLazy = () => {
    return (
        <Suspense fallback={<LoadingUI/>}>
            <AlertsPage />
        </Suspense>
    );
};
